export const TSU_ACCOUNTS_LOGIN_URL = 'https://accounts.tsu.ru/Account/Login2/?applicationId=1047'
